import {
  forwardRef,
  type MouseEvent as ReactMouseEvent,
  type MouseEventHandler,
  type ReactNode,
} from 'react'
import styled from 'styled-components'

import { layoutMixins } from '@/styles/layoutMixins'
import { Logger } from '@/components/Logger'

type ElementProps = {
  analyticsConfig?: {
    event: string
    meta?: unknown
  }
  children: ReactNode
  href?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  withIcon?: boolean
}

type StyleProps = {
  className?: string
}

export const Link = forwardRef<HTMLAnchorElement, ElementProps & StyleProps>(
  (
    {
      analyticsConfig,
      children,
      className,
      href,
      onClick,
      withIcon = false,
      ...props
    }: ElementProps & StyleProps,
    ref,
  ) => (
    <Styled.A
      ref={ref}
      className={className}
      href={href}
      onClick={(e: ReactMouseEvent<HTMLAnchorElement>) => {
        if (analyticsConfig) {
          Logger.log(analyticsConfig)
        }

        onClick?.(e)
      }}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    >
      {children}
      {withIcon && <h2>icon</h2>}
    </Styled.A>
  ),
)

const Styled = {
  A: styled.a<StyleProps>`
    --link-color: inherit;
    color: var(--link-color);

    ${layoutMixins.spacedRow}
    gap: 0.25em;

    &:hover {
      text-decoration: underline;
    }

    &:visited {
      color: var(--link-color);
    }
  `,
}
